<div
  *ngIf="parameters"
  class="html-template"
  [class.animated]="animated$ | async"
  [style.background]="parameters.backgroundColor"
  [style.backgroundImage]="parameters.backgroundImage"
  libHtmlTemplate
  #htmlTemplate="libHtmlTemplate"
  [globalScreenSize]="screenSize"
  [responsive]="responsive">
  <div class="template-wrapper">
    <div class="template-header">
      <img
        *ngIf="parameters.logoUrl"
        alt=""
        [src]="parameters.logoUrl"
        class="template-logo"
        (load)="onLogoLoaded()"
        (error)="onLogoError(parameters.logoUrl)">
    </div>

    <div class="template-content">
      <div class="template-column column-main">
        <div class="column-content">
          <div *ngIf="parameters.titleText || parameters.subtitleText" class="template-content-header">
            <h1 class="template-title" [style.color]="parameters.titleColor + '!important'">
              {{ parameters.titleText }}
            </h1>

            <span class="template-desc" [style.color]="parameters.subtitleColor">
              {{ parameters.subtitleText }}
            </span>
          </div>

          <img
            *ngIf="htmlTemplate.currentScreenSize !== DigitalAssetScreenSize.Full && parameters.qrCodeUrl"
            alt=""
            [src]="parameters.qrCodeUrl"
            class="template-qr-code template-media"
            [class.large-img]="true"
            (load)="onQrCodeLoaded()"
            (error)="onQrCodeError(parameters.qrCodeUrl)">

          <div
            *ngIf="parameters.imageUrl && mainImageHtml"
            class="main-img-animation-wrapper {{ parameters.imageAnimationType }}"
            [class.d-none]="htmlTemplate.currentScreenSize !== DigitalAssetScreenSize.Full && htmlTemplate.currentScreenSize !== DigitalAssetScreenSize.Vertical">
            <div
              class="animated-rectangle"
              [style.background]="parameters.imageColor">
            </div>
<!--            style.fill for svg image only: -->
            <div
              class="main-img-wrapper"
              [innerHTML]="mainImageHtml"
              [style.fill]="parameters.imageColor"
              #mainImageWrapper>
            </div>
          </div>
        </div>
      </div>

      <div class="template-column column-media">
        <img
          *ngIf="htmlTemplate.currentScreenSize === DigitalAssetScreenSize.Full && parameters.qrCodeUrl"
          alt=""
          [src]="parameters.qrCodeUrl"
          class="template-qr-code template-media"
          [class.large-img]="true"
          (load)="onQrCodeLoaded()"
          (error)="onQrCodeError(parameters.qrCodeUrl)">
      </div>
    </div>
  </div>
</div>
